import styles from './ObjectNotFound.module.css';
import Icon from '../Icon';
import Button from '../UI/Button/Button';
import { useNavigate } from 'react-router-dom';
import { FLATS_PAGE, PARKING_PROJECT_PAGE, BUSINESS_PROJECT_PAGE } from '../../router/paths';

export const OBJECT_TYPES = {
  FLAT: 'flat',
  PARKING: 'parking',
  BUSINESS: 'business',
};

const OBJECT_TEXT = {
  [OBJECT_TYPES.FLAT]: {
    title: 'Квартира не&nbsp;найдена',
    buttonText: 'Смотреть квартиры',
    path: FLATS_PAGE,
  },
  [OBJECT_TYPES.PARKING]: {
    title: 'Машино-место не&nbsp;найдено',
    buttonText: 'Смотреть машино-места',
    path: PARKING_PROJECT_PAGE,
  },
  [OBJECT_TYPES.BUSINESS]: {
    title: 'Помещение не&nbsp;найдено',
    buttonText: 'Смотреть помещения',
    path: BUSINESS_PROJECT_PAGE,
  },
};

export default function ObjectNotFound({ type = OBJECT_TYPES.FLAT }) {
  const navigate = useNavigate();

  const { title, buttonText, path } = OBJECT_TEXT[type];

  const handleNavigate = () => {
    navigate(path);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.logo}>
          <Icon name='eyesIcon' width='109' height='100' />
        </div>
        <div className={styles.text_wrapper}>
          <h3 dangerouslySetInnerHTML={{ __html: title }} />
          <p className='text_body_b1'>Вероятно, в&nbsp;ссылке на&nbsp;недвижимость допущена ошибка</p>
        </div>
        <Button roundType='small_rounded' width='fit-content' colorType='gray' onClick={handleNavigate}>
          {buttonText}
        </Button>
      </div>
    </div>
  );
}